import { useQuery } from "@tanstack/react-query";
import { GateView } from "../types";
import { programmeDashboardApi } from "../api/programmeDashboard";

const mapRagLabelToColor = (
  ragLabel: string
): "red" | "green" | "yellow" => {
  if (ragLabel === "At Risk") return "red";
  if (ragLabel === "Watch") return "yellow";
  return "green";
};

export const usePhaseCounts = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["phase-counts", portfolio_id],
    queryFn: () => programmeDashboardApi.fetchPhaseCounts(portfolio_id),
  });

  const gates: GateView[] = data?.data
    ? data.data.map((phase) => ({
      gate: phase.name,
      count: phase.project_count,
      color: mapRagLabelToColor(phase.ragLabel),
    }))
    : [];

  return {
    gates,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch phase counts",
  };
};

